import React, { Component } from "react";
import PropTypes from "prop-types";
import { propTypes, reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import SecretarLogo from "../images/secretar_logo.png";

import LawberryLogo from "../images/lawberry-logo.svg";



import { Notification, translate, userLogin } from "react-admin";

let logo = LawberryLogo;
if (window.location.hostname === 'secretar.me' || window.location.hostname === 'www.secretar.me' || window.location.hostname === 'secretar' || window.location.hostname === 'localhost') {
  logo = SecretarLogo;
}

const styles = theme => ({
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "#000"
  },
  card: {
    minWidth: 300,
    marginTop: "6em"
  },
  logo: {
    marginTop: "10px",
    textAlign: "center"
  },
  icon: {
    backgroundColor: "#000"
  },
  form: {
    padding: "10px 24px"
  },
  input: {
    marginTop: "1em"
  },
  actions: {
    padding: "0 1em 1em 1em",
    marginTop: "20px",
    display: 'block'
  },
  button: {
    backgroundColor: "#000",
    "&:hover": {
      backgroundColor: "#2c9bc3"
    }
  }
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
  meta: { touched, error } = {},
  input: { ...inputProps },
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
);

class Login extends Component {
  login = auth =>
    this.props.userLogin(
      auth,
      this.props.location.state ? this.props.location.state.nextPathname : "/"
    );

  render() {
    const { classes, handleSubmit, isLoading } = this.props;
    return (
      <div className={classes.main}>
        <Card className={classes.card}>
          <div className={classes.logo}>
            <img
              src={logo}
              style={{
                marginTop: 10,
                height: "48px",
                objectFit: "contain"
              }}
              alt="Secretar Logo"
            />
          </div>
          <form onSubmit={handleSubmit(this.login)}>
            <div className={classes.form}>
              <div className={classes.input}>
                <Field
                  name="username"
                  component={renderInput}
                  label='Логин'
                  disabled={isLoading}
                />
              </div>
              <div className={classes.input}>
                <Field
                  name="password"
                  component={renderInput}
                  label='Пароль'
                  type="password"
                  disabled={isLoading}
                />
              </div>
            </div>
            <CardActions className={classes.actions}>
              <Button
                variant="raised"
                type="submit"
                color="primary"
                disabled={isLoading}
                className={classes.button}
                fullWidth
              >
                Войти
              </Button>
              <Button
                variant="raised"
                // type="submit"
                onClick={() => {window.location = 'https://jucrm.ru/oauth/authorize?client_id=2&redirect_uri=https://secretar.me/auth/callback&response_type=code&scope='}}
                color="primary"
                disabled={isLoading}
                className={classes.button}
                style={{marginTop: 10}}
                fullWidth
              >
                Войти через JuCRM
              </Button>
            </CardActions>
          </form>
        </Card>
        <Notification />
      </div>
    );
  }
}

Login.propTypes = {
  ...propTypes,
  authProvider: PropTypes.func,
  classes: PropTypes.object,
  previousRoute: PropTypes.string,
  translate: PropTypes.func.isRequired,
  userLogin: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

const enhance = compose(
  translate,
  reduxForm({
    form: "signIn",
    validate: (values, props) => {
      const errors = {};
      if (!values.username) {
        errors.username = 'Обязательное поле';
      }
      if (!values.password) {
        errors.password = 'Обязательное поле';
      }
      return errors;
    }
  }),
  connect(
    mapStateToProps,
    { userLogin }
  ),
  withStyles(styles)
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.js